export const LEARNING_STATES = {
    Overdue: 'Overdue',
    Bookmarked: 'Bookmarked',
    Completed: 'Completed',
    InProgress: 'InProgress',
    Refresher: 'Refresher',
    Passed: 'Passed',
    Failed: 'Failed',
    Updated: 'Updated',
} as const;

export const LEARNING_PATH_TYPES = {
    Mandatory: 'Mandatory',
    Recommended: 'Recommended',
    Library: 'Library',
    CareerRoadmap: 'CareerRoadmap',
} as const;
